// 取得該團隊的團購方案清單
export class GetGBListByTeam {
  static readonly type = '[VenderGB] GetGBListByTeam';
  constructor(public site_code: string) {}
}

// 取得團購方案detail
export class GetGBDetailByID {
  static readonly type = '[VenderGB] GetGBDetailByID';
  constructor(public groupbuy_instance_id: number) {}
}

//--------------------------------------------
// Vender Groupbuy Instance
//--------------------------------------------
// 發起團購
export class CreateGBI {
  static readonly type = '[VenderGB] CreateGBI';
  constructor(public payload: any) {}
}

// 停止團購(manual stop, submit order)
export class StopGBI {
  static readonly type = '[VenderGB] StopGBI';
  constructor(public payload: any) {}
}

// 取消團購(manual stop, cancel all orders)
export class CancelGBI {
  static readonly type = '[VenderGB] CancelGBI';
  constructor(public payload: any) {}
}

// 取得團購Instance清單 by site
export class GetGBIListBySite {
  static readonly type = '[VenderGB] GetGBIListBySite';
  constructor(public site_code: string) {}
}

// 取得團購Instance detail by id
export class GetGBIDetailByID {
  static readonly type = '[VenderGB] GetGBIDetailByID';
  constructor(public groupbuy_instance_id: number) {}
}

// 取得團購Instance Txn list
export class GetGBITxnList {
  static readonly type = '[VenderGB] GetGBITxnList';
  constructor(public payload: any) {}
}

// 取得團購Instance return list
export class GetGBIReturnList {
  static readonly type = '[VenderGB] GetGBIReturnList';
  constructor(public payload: any) {}
}

// 退貨團購(醫護人員使用)
export class DoGBITxnReturn {
  static readonly type = '[VenderGB] DoGBITxnReturn';
  constructor(public payload: any) {}
}

// 加入團購,新增預約名單(醫護人員使用)
export class DoGBITxnAdd {
  static readonly type = '[VenderGB] DoGBITxnAdd';
  constructor(public payload: any) {}
}

// 團購標註已領取(醫護人員使用)
export class DoGBITxnReceived {
  static readonly type = '[VenderGB] DoGBITxnReceived';
  constructor(public payload: any) {}
}

// 取得團購數量統計 by site_codes(多個)
export class GetGBIStatisticsBySiteCodes {
  static readonly type = '[VenderGB] GetGBIStatisticsBySiteCodes';
  constructor(public site_codes: string[]) {}
}

// 加入團購,新增預約名單(個案自行加入使用)
export class JoinGBI {
  static readonly type = '[VenderGB] JoinGBI';
  constructor(public payload: any) {}
}

// 退出團購,移除預約名單(個案自行退出使用)
export class LeaveGBI {
  static readonly type = '[VenderGB] LeaveGBI';
  constructor(public payload: any) {}
}

// 取得我的團購清單
export class GetMyGBITxnList {
  static readonly type = '[VenderGB] GetMyGBITxnList';
  constructor(public payload: any) {}
}

// 評論商品
export class DoGBIItemComment {
  static readonly type = '[VenderGB] DoGBIItemComment';
  constructor(public payload: any) {}
}
